import { useMemo, type ReactNode } from 'react';
import { AppLayout } from 'src/components/layout/app-layout';
import { PipelineSubNav } from './components/pipeline-sub-nav';

type BillingPipelineShellProps = {
  readonly children: ReactNode;
  readonly beforeNav?: ReactNode;
};

export function BillingPipelineShell({ children, beforeNav }: BillingPipelineShellProps) {
  const navbarProps = useMemo(
    () => ({
      showBackButton: true as const,
      backPath: '/billing',
      children: beforeNav,
    }),
    [beforeNav]
  );

  return (
    <AppLayout
      activePage="/billing"
      navbarProps={navbarProps}
    >
      <div className="h-[calc(100vh-8rem)] overflow-hidden flex flex-col">
        <PipelineSubNav />
        <div className="flex-1 min-h-0 overflow-auto">
          {children}
        </div>
      </div>
    </AppLayout>
  );
}
